import { ProjectAbstract } from '@/domain/project/entities/project.entity';

import { forcedTimezone } from './timezone';

export const formatProjectDatesFromProject = (project: ProjectAbstract) => {
  if (!project.startDate || !project.endDate) {
    return '';
  }
  return formatProjectDates(project.startDate, project.endDate);
};

export const formatProjectDates = (startDate: string, endDate: string) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const durationOnSameMonth = start.getMonth() === end.getMonth();
  return `Du ${days[start.getDay()]}. ${start.getDate()} ${
    durationOnSameMonth ? '' : months[start.getMonth()]
  } au ${end.getDate()} ${months[end.getMonth()]} ${end.getFullYear()}`;
};

export const formatProjectDatesTz = (startDate: string, endDate: string) => {
  const inputLocaleFormat = 'en-US'; // to parse 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  const start = new Date(
    new Date(startDate).toLocaleString(inputLocaleFormat, {
      timeZone: forcedTimezone,
    }),
  );
  const end = new Date(
    new Date(endDate).toLocaleString(inputLocaleFormat, {
      timeZone: forcedTimezone,
    }),
  );

  const durationOnSameMonth = start.getMonth() === end.getMonth();
  return `Du ${days[start.getDay()]}. ${start.getDate()} ${
    durationOnSameMonth ? '' : months[start.getMonth()]
  }${start.getFullYear() !== end.getFullYear() ? ' ' + start.getFullYear() : ''} au ${end.getDate()} ${months[end.getMonth()]} ${end.getFullYear()}`;
};

const days = ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'];
const months = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];
